// extracted by mini-css-extract-plugin
module.exports = {"role-selector":"InviteUserForm_role-selector__3xKQi","role-select-dropdown":"InviteUserForm_role-select-dropdown__ZYjyx"};